<template>
  <div :id="id" :style="{ height: resolveHeight, width: resolveWidth }"></div>
</template>

<script setup lang="ts">
import useScatterChart from './hooks/useScatterChart';

interface Props {
  rawData?: Charts.ChartsProps.RawData;
  colorList: Charts.ChartsProps.ColorItem[];
  height?: number | string;
  width?: number | string;
  responsiveWidth?: boolean;
  responsiveHeight?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  height: 800,
  width: 300,
});

const { id, resolveHeight, resolveWidth } = useScatterChart(props);
</script>
